module.exports = __webpack_public_path__ + "static/media/29.d15830d1.jpg";